import "./not-found.scss"
import Seo from "../Seo";

const NotFound = () => {
    return <div className="not-found-wrapper">
        <Seo title="Page Not Found | Leader Auto Ship" description="This page does not exist." noindex/>
        <div className="sloy">
            <div className="text1">
                <div className="error">
                    error 404
                </div>
                <div className="text">
                    Page not found
                </div>
            </div>
        </div>
    </div>
};

export default NotFound